import { api, unwrap } from "@lumberset/api-client";
import { queryOptions } from "@tanstack/react-query";

/**
 * The learning loop: how far Reading was from what Reviewers approved, and the
 * Reading Lessons learned from their Corrections. Keys start with "accuracy"
 * and "lessons", which is what the screens' mutations invalidate.
 */

/** Every approved Review of a reading in the last N days, with the weekly trend. */
export const agreementQuery = (days: number) =>
  queryOptions({
    queryKey: ["accuracy", "agreement", days],
    queryFn: () => unwrap(api.staff.accuracy.agreement.$get({ query: { days: String(days) } })),
  });

/** One approved Review: the Materials that moved and each Correction. */
export const agreementReviewQuery = (reviewId: string) =>
  queryOptions({
    queryKey: ["accuracy", "agreement", "review", reviewId],
    queryFn: () => unwrap(api.staff.accuracy.agreement[":reviewId"].$get({ param: { reviewId } })),
  });

/** Every Reading Lesson, and what suggestions have spent today. */
export const lessonsQuery = queryOptions({
  queryKey: ["lessons"],
  queryFn: () => unwrap(api.staff.lessons.$get({ query: {} })),
});

/** Recent Corrections, to pick the ones a lesson comes from. */
export const lessonCorrectionsQuery = queryOptions({
  queryKey: ["lessons", "corrections"],
  queryFn: () => unwrap(api.staff.lessons.corrections.$get({ query: {} })),
  staleTime: 60_000,
});

export type Lesson = Awaited<
  ReturnType<NonNullable<typeof lessonsQuery.queryFn>>
>["lessons"][number];

export type LessonCorrection = Awaited<
  ReturnType<NonNullable<typeof lessonCorrectionsQuery.queryFn>>
>["corrections"][number];
